/**
 * Per-style canvas layout facts. `primaryMax` mirrors validatePassDesign
 * (boardingPass 2, everything else 1) — the server is the source of truth,
 * this only pre-empts the 422 by hiding the "+" at the cap.
 */
import type { AppleStyle } from '../../walletStyles';

export interface CanvasLayout {
  /** boardingPass renders primary as ORIGIN ✈ DESTINATION with the transit icon. */
  originDestination: boolean;
  primaryMax: number;
}

export function layoutForStyle(style: AppleStyle): CanvasLayout {
  return {
    originDestination: style === 'boardingPass',
    primaryMax: style === 'boardingPass' ? 2 : 1,
  };
}
